export const GET_DELAY_REASONS_REQUEST = 'GET_DELAY_REASONS_REQUEST' as const;
export const GET_DELAY_REASONS_SUCCESS = 'GET_DELAY_REASONS_SUCCESS' as const;
export const GET_DELAY_REASONS_ERROR = 'GET_DELAY_REASONS_ERROR' as const;
export const SAVE_DELAY_REASON_REQUEST = 'SAVE_DELAY_REASON_REQUEST' as const;
export const DELETE_DELAY_REASON_REQUEST = 'DELETE_DELAY_REASON_REQUEST' as const;
